var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Input } from '../../input';
// eslint-disable-next-line prefer-arrow-callback
export const NativeDatepicker = forwardRef(function NativeDatePickerWithRef(_a, ref) {
    var { onChange } = _a, props = __rest(_a, ["onChange"]);
    return (React.createElement(Input, Object.assign({ ref: ref, type: "date", onChange: (event) => {
            if (onChange === undefined) {
                return;
            }
            onChange(event);
        } }, props)));
});
//# sourceMappingURL=NativeDatepicker.js.map